import React, { useState, useEffect } from "react"
import {TableContainer,TableCell,Table, TableHead,Paper, TableRow,TableBody,} from "@mui/material";
import moment from "moment";
import { getData } from "../../../../../services/library";


export default function HistorialPreciosEspeciales({dataCliente}){

const [precios, setPrecios] = useState([]);

    useEffect(() => {
        getData(`/precios_especiales/historialxcliente/${dataCliente.id_cliente}`, setPrecios)
    }, []);


    return(
        <div>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead sx={{ backgroundColor: "#535e66" }}>
                        <TableRow>
                            <TableCell sx={{ color: "white" }}>Litro sin IVA</TableCell>
                            <TableCell sx={{ color: "white" }}>Litro con IVA</TableCell>
                            <TableCell sx={{ color: "white" }}>Kilo sin IVA</TableCell>
                            <TableCell sx={{ color: "white" }}>Kilo con IVA</TableCell>
                            <TableCell sx={{ color: "white" }}>Inicio</TableCell>
                            <TableCell sx={{ color: "white" }}>Fin</TableCell>
                            <TableCell sx={{ color: "white" }}>Actualización</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {precios && precios.map((row, index) => (
                            <TableRow
                                key={index}>

                                <TableCell>${row.lt_sin_iva}</TableCell>
                                <TableCell>${row.lt_con_iva}</TableCell>
                                <TableCell>${row.kg_sin_iva}</TableCell>
                                <TableCell>${row.kg_con_iva}</TableCell>
                                <TableCell>{moment(row.vigencia).format("DD-MM-YYYY")}</TableCell>
                                <TableCell>{row.fin_vigencia ? moment(row.fin_vigencia).format("DD-MM-YYYY") : "-"}</TableCell>
                                <TableCell>{row.aumento_en_pesos ? `$ ${row.aumento_en_pesos}` : (row.aumento_en_porcentaje ? `${row.aumento_en_porcentaje} %` : null)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer> 

        </div>
    )
}


    
